import PropTypes from 'prop-types'
import React, { Component } from 'react'

import {
  COLOR_WHITE,
  COLOR_WHITE_MUTED,
  COLOR_BLACK,
  COLOR_BLACK_MUTED,
  COLOR_FAILED,
} from 'styles/theme/colors'
import './StripeFieldWrapper.scss'

export default class StripeFieldWrapper extends Component {
  static propTypes = {
    /** Field id to get in callback */
    id: PropTypes.string.isRequired,

    /** Label for field */
    label: PropTypes.string.isRequired,

    /** Constructor/Function of component */
    StripeField: PropTypes.func.isRequired,

    /** Reference to cvc field */
    cvcFieldRef: PropTypes.object,

    /** Flag to invert colors */
    isLight: PropTypes.bool,

    /** Custom text for placeholder */
    placeholder: PropTypes.string,

    /** On field ready cb */
    onReady: PropTypes.func,

    /** Callback when brand of pay system was determined */
    onBrandDetermined: PropTypes.func,

    /** Callback when change field fill complete status */
    onFiledCompleteChange: PropTypes.func,
  }

  static defaultProps = {
    isLight: false,
  }

  _isMounted = false

  constructor(props) {
    super(props)

    this.state = {
      isHovered: false,
      errorMessage: null,
      brandCode: null,
      isComplete: false,
    }
  }

  componentDidMount() {
    this._isMounted = true
  }

  componentDidUpdate(prevProps, prevState) {
    const { onBrandDetermined, onFiledCompleteChange, id } = this.props
    const { brandCode, isComplete } = this.state

    if (brandCode && onBrandDetermined && brandCode !== prevState.brandCode) {
      onBrandDetermined({ brand: brandCode })
    }

    if (onFiledCompleteChange && isComplete !== prevState.isComplete) {
      onFiledCompleteChange({ id, isComplete })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleBlur = () => {
    if (this._isMounted)
      this.setState({
        isHovered: false,
      })
  }

  handleFocus = () => {
    this.setState({
      isHovered: true,
    })
  }

  handleChange = changeObject => {
    const { error, brand, complete } = changeObject
    const { errorMessage, brandCode } = this.state
    const nextState = {
      isComplete: complete,
    }

    if (error && error.code && !errorMessage) {
      nextState.errorMessage = error.message
    }

    if (typeof error === 'undefined' && errorMessage) {
      nextState.errorMessage = null
    }

    if (brand && brand !== brandCode) {
      nextState.brandCode = brand
    }

    if (Object.keys(nextState).length > 0) {
      this.setState(nextState)
    }
  }

  render() {
    const {
      StripeField,
      label,
      isLight,
      placeholder,
      cvcFieldRef,
      onReady,
    } = this.props
    const { isHovered, errorMessage } = this.state
    const inputTextColor = isLight ? COLOR_WHITE : COLOR_BLACK
    const placeholderTextColor = isLight ? COLOR_WHITE_MUTED : COLOR_BLACK_MUTED
    let labelClassNames = 'stripe-field-wrapper__label '
    let underlineClassNames = 'stripe-field-wrapper__underline '
    let fieldWrapperClassNames = 'stripe-field-wrapper__input-wrapper '

    labelClassNames += isLight ? 'stripe-field-wrapper__label--inverted ' : ''
    underlineClassNames += isHovered
      ? 'stripe-field-wrapper__underline--hovered '
      : ''
    underlineClassNames += errorMessage
      ? 'stripe-field-wrapper__underline--error '
      : ''
    underlineClassNames += isLight
      ? 'stripe-field-wrapper__underline--inverted '
      : ''
    fieldWrapperClassNames += errorMessage
      ? 'stripe-field-wrapper__input-wrapper--error '
      : ''

    return (
      <div>
        <div className={labelClassNames}>
          <span dangerouslySetInnerHTML={{ __html: label }} />
        </div>
        <div className={fieldWrapperClassNames}>
          <StripeField
            className="stripe-field-wrapper__input"
            style={{
              base: {
                color: inputTextColor,
                fontSize: '16px',
                fontFamily: 'Abel,DinPro_regular,Arial,Helvetica,sans-serif',
                '::placeholder': {
                  color: placeholderTextColor,
                },
              },
              invalid: {
                color: COLOR_FAILED,
              },
            }}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            onChange={this.handleChange}
            onReady={onReady}
            placeholder={isHovered ? '' : placeholder}
            ref={cvcFieldRef}
          />
          <div className={underlineClassNames} />
          {errorMessage ? (
            <div className="stripe-field-wrapper__error text--danger">
              <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}
